import { isAfter, isBefore, startOfDay, endOfDay } from 'date-fns';
import type { InquiryItem } from '@/types/api';
import { TabKey } from '../_consts/inquiryConstants';

export function filterInquiriesByDate(
  orders: InquiryItem[],
  startDate?: Date,
  endDate?: Date,
): InquiryItem[] {
  if (!startDate || !endDate) return orders;
  const start = startOfDay(startDate);
  const end = endOfDay(endDate);
  return orders.filter((order) => {
    const orderDate = new Date(order.InquiryDate);
    return (
      (isAfter(orderDate, start) || orderDate.getTime() === start.getTime()) &&
      (isBefore(orderDate, end) || orderDate.getTime() === end.getTime())
    );
  });
}

export function sortInquiries(reviews: InquiryItem[], sortKey: string): InquiryItem[] {
  const sorted = [...reviews];
  switch (sortKey) {
    case 'latest':
      sorted.sort((a, b) => new Date(b.InquiryDate).getTime() - new Date(a.InquiryDate).getTime());
      break;
    case 'oldest':
      sorted.sort((a, b) => new Date(a.InquiryDate).getTime() - new Date(b.InquiryDate).getTime());
      break;
    default:
      break;
  }
  return sorted;
}

export function getTabListWithCounts(orders: InquiryItem[]) {
  const notYet = orders.filter((r) => r.CheckedYn === 'N').length;
  const completed = orders.filter((r) => r.CheckedYn === 'Y').length;

  return [
    { key: 'not-yet', label: '미답변', count: notYet },
    { key: 'completed', label: '답변완료', count: completed },
  ];
}

export function filterInquiriesByTab(reviews: InquiryItem[], tab: TabKey): InquiryItem[] {
  switch (tab) {
    case 'not-yet':
      return reviews.filter((r) => r.CheckedYn === 'N');
    case 'completed':
      return reviews.filter((r) => r.CheckedYn === 'Y');
    default:
      return reviews;
  }
}
